// extracted by mini-css-extract-plugin
export default {"c_video__poster":"style_c_video__poster_1OUnK","playerbutton":"style_playerbutton_cV9ZZ","narrowWindow":"style_narrowWindow_VlfUU"};